import baseConfig from '@/config/index';
import Aegis from '@tencent/aegis-web-sdk';
const aegis = new Aegis({
  id: baseConfig.aegisKey, // 项目ID，即上报id
  // uin: '', // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true,
});
export const reportAegisError = ({ type, error, extra = {} }) => {
  extra = {
    ...extra,
    env: process.env.VUE_APP_ENV,
  };
  // eslint-disable-next-line no-param-reassign
  const reportData = {
    type,
    error,
    ...extra,
  };
  aegis.report(JSON.stringify(reportData));
};
